<template>
    <div>

        <a @click.prevent="load()" href="#" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
            <!-- Heroicon name: pencil-alt -->
            <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
            </svg>
            Edit
        </a>

        <div v-if="editItem" class="bg-blue-50 border-blue-400 rounded-lg my-4 pt-8 pb-5 px-5 relative">
            <!-- This example requires Tailwind CSS v2.0+ -->
            <div class="fixed z-10 inset-0 overflow-y-auto">
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 transition-opacity" aria-hidden="true" @click="editItem = false">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all ease-out duration-300 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <div class="flex justify-between items-center mb-4">
                            <p class="text-xl font-semibold text-gray-900">Edit Item</p>
                            <svg @click="editItem = false" class="w-6 h-6 text-gray-400 cursor-pointer hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                        </div>
                        <form @submit.prevent="submit"  class="grid grid-cols-6 gap-6">
                            <div class="col-span-6 sm:col-span-3">
                                <label for="market_price" class="block text-sm font-medium text-gray-700">Market Price</label>
                                <text-input v-model="item.market_price" type="number" step=".01" name="market_price" id="market_price" class="mt-1" />
                            </div>
                            <div class="col-span-6">
                                <label for="comments" class="block text-sm font-medium text-gray-700">Comments</label>
                                <textarea v-model="item.comments" ref="comments" id="comments" name="comments" rows="4" class="mt-2 shadow-sm block w-full focus:ring-blue-500 focus:border-blue-500 font-mono sm:text-sm border-gray-300 rounded-md"></textarea>
                            </div>
                            <div class="col-span-6 grid grid-cols-12 gap-2">
                                <div class="col-span-12 sm:col-span-5">
                                    <label for="availalbe_zones" class="block text-sm font-medium text-gray-700">Available Zones</label>
                                    <select-input v-model="selectedAvailableZones" multiple size="10" name="availalbe_zones" id="availalbe_zones" class="mt-1">
                                        <option v-for="(availableZone, idx) in availableZones" :value="idx">{{ availableZone.name }}</option>
                                    </select-input>
                                </div>
                                <div class="flex flex-col items-center justify-center col-span-12 sm:col-span-2">
                                    <button @click="unAssignZones()" v-if="selectedAssignedZones.length" type="button" class="w-12 inline-flex items-center p-3 my-2 border border-transparent rounded-full shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                                        </svg>
                                    </button>
                                    <button @click="assignZones()" v-if="selectedAvailableZones.length" type="button" class="inline-flex items-center p-3 my-2 border border-transparent rounded-full shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </button>
                                </div>
                                <div class="col-span-12 sm:col-span-5">
                                    <label for="assigned_zones" class="block text-sm font-medium text-gray-700">Assigned Zones</label>
                                    <select-input v-model="selectedAssignedZones" multiple size="10" name="assigned_zones" id="assigned_zones" class="mt-1">
                                        <option v-for="(assignedZone, idx) in assignedZones" :value="idx">{{ assignedZone.name }}</option>
                                    </select-input>
                                </div>
                            </div>
                            <div class="col-span-6">
                                <div class="flex justify-end items-center mt-2">

                                    <loading-button :loading="saving"  type="submit" class="">
                                        Save
                                    </loading-button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

import LoadingButton from "@/Shared/LoadingButton";
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'

export default {
    components: { LoadingButton, TextInput, SelectInput },
    props: {
        item: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            saving: false,
            editItem: false,
            assignedZones: this.item.zones,
            availableZones: [],
            selectedAvailableZones: [],
            selectedAssignedZones: [],
        }
    },
    methods: {
        load() {
            this.editItem = true
            axios.get( route('settings.mill-prices.available-zones')).then(
                response => this.availableZones = response.data
            )
        },
        assignZones() {
            this.selectedAvailableZones.forEach(selectedZone => {
                this.assignedZones.push(this.availableZones[selectedZone])
            })
            this.availableZones = this.availableZones.filter((el, index) => ! this.selectedAvailableZones.includes(index) )
            this.assignedZones.sort((a, b) => (a.name > b.name ? 1 : -1))
            this.selectedAvailableZones = []
            this.selectedAssignedZones = []
        },
        unAssignZones() {
            this.selectedAssignedZones.forEach(selectedZone => {
                this.availableZones.push(this.assignedZones[selectedZone])
            })
            this.assignedZones = this.assignedZones.filter((el, index) => ! this.selectedAssignedZones.includes(index) )
            this.availableZones.sort((a, b) => (a.name > b.name ? 1 : -1))
            this.selectedAvailableZones = []
            this.selectedAssignedZones = []
        },
        submit() {
            this.item.zones = this.assignedZones
            this.$inertia.put(this.route('settings.market-prices.update', this.item.id), this.item, {
                onStart: () => this.saving = true,
                onFinish: () => this.saving = false,
                onSuccess: () => this.editItem = false,
            })
        }
    },
    watch: {
        editItem() {
            if (! this.editItem) {
                this.$emit('close-menu')
            }
        }
    }
}
</script>
